import { useId } from 'react';
import Filters from 'src/components/form/filters/filters';
import { searchInputValidationSchema } from 'src/components/form/search/filters-form/helper';
import SearchInput from 'src/components/form/search/filters-form/search-input';
import css from './news.module.scss';
import { NewsFiltersProps } from './interfaces';

interface FiltersProps {
  initialFilters: Partial<NewsFiltersProps>;
  onSearch: (filters: Partial<NewsFiltersProps>) => void;
}

export default function NewsFilters({ onSearch, initialFilters }: Readonly<FiltersProps>) {
  const inputId = useId();

  return (
    <Filters
      initialFilters={initialFilters}
      onSearch={onSearch}
      validationSchema={searchInputValidationSchema('search')}
      fieldsToSubmitOnChange={['search']}
      render={({ errors, _, registerAndClearOnChange }) => (
        <div className={css.filtersGroup}>
          <SearchInput
            id={inputId}
            name='search'
            placeholder='Шукати новину'
            error={errors?.text?.message}
            inputProps={registerAndClearOnChange('search')}
          />
        </div>
      )}
    />
  );
}
